export default async function ({store, redirect}) {
    // await store.dispatch('managerProject/fetch');
    console.log('/// *** ///');
    // console.log('middleware::manager > TEST', store);
}
